module.exports = __webpack_public_path__ + "30c5e0ed0cebb9bb4ef67b9aaf0a8255.svg";